let _ = (t)=>t, t;
import { jsx as _jsx } from "react/jsx-runtime";
import { css } from '@emotion/react';
import RichTextMarkdown from 'components/richTextMarkdown/RichTextMarkdown';
import { useTheme } from 'features/fabric';
import { useTranslate } from 'utils/Translate';
const InstallmentDisclaimer = ({ translationKey })=>{
    const translate = useTranslate();
    const theme = useTheme();
    if (!translationKey) {
        return null;
    }
    return /*#__PURE__*/ _jsx(RichTextMarkdown, {
        sx: css(t || (t = _`
        max-width: 100%;

        p,
        p > *,
        a {
          font-size: ${0};
          line-height: ${0};
          color: ${0};
        }
        a:hover {
          color: ${0};
        }
      `), theme.textSize.s, theme.textLineHeight.s, theme.color.textTertiary, theme.color.textTertiary),
        children: translate(translationKey)
    });
};
export default InstallmentDisclaimer;
